import { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CarCard2 from '../components/CarCard2';

export default function Financing() {
  const [cars, setCars] = useState([]);

  useEffect(() => {
    const fetchFinancingCars = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/cars/financing`);
        setCars(res.data);
      } catch (err) {
        console.error('Error fetching financing cars:', err.message);
      }
    };
    fetchFinancingCars();
  }, []);

  return (
    <div className="bg-gradient-to-b from-gray-100 to-blue-100 text-gray-800 min-h-screen">
      <Navbar />
      <div className="container mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold mb-6 text-blue-900">Financing Options</h1>
        <p className="mb-6 text-lg text-gray-700">
          Explore cars available for financing and calculate your loan options below.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cars.map(car => (
            <div key={car.id}>
              <CarCard2 car={car} />
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}